import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { saveChecklists } from 'redux/checklistSlice';
import { useGetChecklistsByProjectIdMutation } from 'redux/services/checklists';
import { RootStates } from 'redux/store';

export const useGetChecklist = () => {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const checklist = useSelector(
    (state: RootStates) => state.checklist.checklists,
  );

  const [getChecklists, { data: checklistData, isSuccess }] =
    useGetChecklistsByProjectIdMutation();

  const getAllChecklists = useCallback(async () => {
    getChecklists(projectId);
  }, [getChecklists, projectId]);

  useEffect(() => {
    if (checklistData) {
      dispatch(saveChecklists(checklistData));
    }
  }, [checklistData, dispatch]);

  useEffect(() => {
    if (!isSuccess) {
      getAllChecklists();
    }
  }, [checklist, getAllChecklists, isSuccess]);

  return checklist;
};
